import { axiosInstance } from "./axiosConfig";
import { isAxiosError } from "axios";

interface Hospital {
  id: number;
  name: string;
}

interface HospitalsSuccessResponse {
  results: Hospital[];
  count?: number;
}


interface GenericErrorResponse {
  error?: string;
}


interface HospitalsResult {
  data: HospitalsSuccessResponse | GenericErrorResponse;
  status: number;
}


export const getHospitals = async (
  language: 'az' | 'en' = 'az'
): Promise<HospitalsResult> => {
  try {
    const response = await axiosInstance.get<HospitalsSuccessResponse>(
      '/health/hospitals',
      {
        params: {
          is_active: true
        },
        headers: {
          'Accept-Language': language,
          'Content-Type': 'application/json'
        }
      }
    );

    return {
      data: response.data,
      status: response.status
    };

  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        return {
          data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
          status: error.response.status
        };
      }

      if (error.request) {
        return {
          data: { error: 'Şəbəkə xətası - cavab alınmadı' },
          status: 0
        };
      }
    }

    return {
      data: {
        error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
      },
      status: -1
    };
  }
};